"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var getZkSyncTransactionExplorerUrl = function getZkSyncTransactionExplorerUrl(txHash, networkName) {
  if (networkName === void 0) {
    networkName = 'mainnet';
  }

  txHash = (txHash || '').toLowerCase();
  networkName = (networkName || '').toLowerCase();
  var subdomain = '';

  if (networkName !== 'mainnet') {
    subdomain = networkName + ".";
  }

  txHash = txHash.replace(/^(sync-tx:|sync-tx:0x|0x)?/, 'sync-tx:');
  return "https://" + subdomain + "zkscan.io/explorer/transactions/" + txHash;
};

exports.default = getZkSyncTransactionExplorerUrl;